export const DRAFT = 'draft';
export const REVIEW = 'review';
export const PUBLISHED = 'published';
export const UPDATE_PUBLISHED = true;

export const isPublished = event => (event || {}).status === PUBLISHED;
export const isUpdatePublished = update => (update || {}).published === UPDATE_PUBLISHED;
